import { render, staticRenderFns } from "./AdminChat.vue?vue&type=template&id=c3f9fa00&scoped=true"
import script from "./AdminChat.vue?vue&type=script&lang=js"
export * from "./AdminChat.vue?vue&type=script&lang=js"
import style0 from "./AdminChat.vue?vue&type=style&index=0&id=c3f9fa00&prod&lang=css"
import style1 from "./AdminChat.vue?vue&type=style&index=1&id=c3f9fa00&prod&scoped=true&lang=css"
import style2 from "./AdminChat.vue?vue&type=style&index=2&id=c3f9fa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f9fa00",
  null
  
)

export default component.exports